
import { defineComponent, computed, PropType, watch, ref } from 'vue'
import { Cell, Checkbox, CheckboxGroup } from 'vant'
import { CellSelectOptionModel } from './CellSelect.model'

export default defineComponent({
  name: 'CellSelect',
  components: {
    'van-cell': Cell,
    'van-checkbox': Checkbox,
    'van-checkbox-group': CheckboxGroup
  },
  props: {
    modelValue: { type: Object as PropType<any> },
    options: { type: Array as PropType<CellSelectOptionModel[]>, default: () => [] },
    type: { type: String, default: 'radio' },
    max: { type: Number, default: 0 },
    optionAsValue: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const checkboxes = ref()
    const needEmitChange = ref(true)
    const realValue = ref<any[]>([])
    const indexForRadio = ref(0)

    const realOptionAsValue = computed<boolean>(
      () => typeof props.optionAsValue === 'string' || !!props.optionAsValue
    )
    const realMax = computed<number>(() => {
      if (props.type === 'radio') return 0
      return props.max
    })
    function emitUpdateValue(value: any) {
      emit('update:modelValue', value)
    }
    function emitInput(value: any) {
      emit('input', value)
    }
    function emitChange(value: any) {
      emitUpdateValue(value)
      emitInput(value)
      emit('change', value)
    }
    function transIndexForRadio() {
      const value = props.modelValue
      const options = props.options
      if (options) {
        if (realOptionAsValue.value) {
          indexForRadio.value = options.indexOf(value)
          indexForRadio.value = Math.max(0, indexForRadio.value)
        } else {
          const has = options.some((option: any, index: number) => {
            const res = option.value === value
            if (res) {
              indexForRadio.value = index
            }
            return res
          })
          if (!has) indexForRadio.value = 0
        }
      }
    }
    // 对 radio 和 checkbox 做统一的数据结构处理
    function transRealValue(needEmit = true) {
      if (props.type === 'radio') {
        if (props.modelValue instanceof Array) {
          realValue.value = props.modelValue
        } else if (props.modelValue) {
          realValue.value = [props.modelValue]
        } else {
          realValue.value = []
        }
        needEmitChange.value = needEmit
        transIndexForRadio()
      } else {
        realValue.value = props.modelValue
      }
    }
    function handleGroupChange(value: any[]) {
      if (needEmitChange.value) {
        if (props.type === 'radio' && value.length) {
          emitChange(value.pop())
        } else if (props.type === 'checkbox') {
          emitChange(value)
        }
      } else {
        needEmitChange.value = true
      }
    }
    transRealValue(true)
    function handleOptionChange(index: number) {
      if (props.type === 'radio') {
        try {
          checkboxes.value[indexForRadio.value].toggle(false)
        } catch (error) {}
        checkboxes.value[index].toggle(true)
        if (indexForRadio.value === index) {
          if (realOptionAsValue.value) {
            emitChange(props.options![index])
          } else {
            emitChange(props.options![index].value)
          }
        }
        indexForRadio.value = index
      } else {
        checkboxes.value[index].toggle()
      }
    }
    // 判定当前是否为选中的值
    function judgeIsCurrent(item: any) {
      if (realOptionAsValue.value) {
        return realValue.value
          .map((option: CellSelectOptionModel) => option.value)
          .includes(item.value)
      }
      return realValue.value.includes(item.value)
    }
    watch(
      () => props.modelValue,
      () => {
        const needEmit = props.type !== 'radio'
        transRealValue(needEmit)
      }
    )
    return {
      realMax,
      realValue,
      checkboxes,
      realOptionAsValue,
      judgeIsCurrent,
      handleGroupChange,
      handleOptionChange
    }
  }
})
